import "./HVACAirDucts.module.css";
import Header from "@/reusable_sections/Header";
import TechnicalTreatment from "./sections/TechnicalTreatment";
import Componenti from "./sections/Componenti";
import Footer from "@/reusable_sections/Footer";
export default function HVACAirDuctsPage() {
  return <div>
      <Header />
      <TechnicalTreatment />
      <Componenti />
      <Footer />
    </div>;
}